import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { insPacingPlansStateId } from "common/constants";
import { useDeleteObjectiveMutation } from "components/commitment-pacing/store/api";
import { language } from "language/default";
import { handleDeletePacingPlanButtonClicked } from "components/pages/pacing-plans/insPacingPlans";
import { closeDialog } from "store/messages-dialog";
export const InsDeletePacingPlanDialogAction = () => {
    const dispatch = useDispatch();
    const [deleteObjective, { isLoading }] = useDeleteObjectiveMutation();
    const selectedRows = useSelector((state) => state.grids.state[insPacingPlansStateId]?.selectedRows, isEqual) ?? [];
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "main-delete-button", isDisabled: isLoading, icon: isLoading ? "loading" : undefined, type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: async () => {
                if (selectedRows?.length) {
                    try {
                        await Promise.all(selectedRows.map((name) => deleteObjective({ name })));
                        handleDeletePacingPlanButtonClicked(dispatch);
                        dispatch(closeDialog());
                    }
                    catch (error) {
                        dispatch(closeDialog());
                    }
                }
                else {
                    dispatch(closeDialog());
                }
            } }),
        React.createElement(CloseDialogButton, null));
};
